module.exports = {
  "下载":"Scarica",
  "打开":"Apri",
  language: {
    "name":"简体中文",
    "title":"选择语言",
    subList: [
      {
        name:"English",
        link:"en",
      },
      // {
      //   name:"简体中文",
      //   link:"zh",
      // },
      {
          name:"繁體中文",
          link:"tw",
      },
      {
        name:"日本語",
        link:"jp",
      },
      {
        name:"한국어",
        link:"kr",
      },
      {
        name:"ไทย",
        link:"th",
      },
      {
        name:"Tiếng Việt",
        link:"vn",
      },
      {
        name:"Español",
        link:"es",
      },
      {
        name: 'Deutsch',
        link: 'de',
      },
      {
        name: 'Français',
        link: 'fr',
      },
      {
        name: 'Italia',
        link: 'it',
      },
      {
        name: 'Portugal',
        link: 'pt',
      },
      {
        name: 'Расея',
        link: 'ru',
      },
      {
        name: 'عربي',
        link: 'ar',
      },
    ]
  },
  "user":{//my
    "wdtd":"Il mio team",
    "wdyj":"La mia performance",
    "ren":"persona",
  },
  "kjsy": {
    "title":"Entrate",
    "fxsy":"Condivisione delle entrate",
    "zjlsl":"Importo totale della ricompensa",
    "jl":"Ricompensa",
    "sj":"Data",
    "sl":"Quantità",
    "sm":"Descrizione",
  },
  pay:{//purchase
    "title":"Acquista macchina per il mining",
    "gmsl":"Quantità di acquisto",
    "zf":"Pagamento",
    "kyye":"Saldo disponibile",
    "kyyebz":"Saldo disponibile insufficiente",
    "bztbtips":"L'importo di prelievo immesso è inferiore al requisito di prelievo minimo di questa valuta",
    "bztbtips2":"L'importo di prelievo non può essere inferiore al prelievo minimo",
    "qsrjymm":"Inserisci una password di transazione a 6 cifre",
    "wxts":"Promemoria",
  },
  chongbi:{
    "title":"Deposito",
    "lianmc":"Tipo di catena",
    "scl":"Genera catena esclusiva",
    "sy":"Chiave privata",
    "ewm":"Codice QR",
    "bcewm":"Salva il codice QR",
    "cbdz":"Indirizzo di deposito",
    "fz":"Copia",
    "sl":"Importo del deposito",
    "qsrsl":"Inserisci l'importo del deposito",
    "sjczje":"Importo effettivo della ricarica",
    "qsrsjczje":"Inserisci l'importo effettivo della ricarica",
    "pzms":"Descrizione del certificato",
    "qsrms":"Inserisci una descrizione",
    "hxz":"Valore hash",
    "qsrhxz":"Inserisci il valore hash",
    "pztp":"Immagine del voucher",
    "qscpztp":"Carica l'immagine del certificato",
    "fzcg":"Copia riuscita",
    "yhkcz":"Ricarica carta di credito",
    "usdtcz":"Ricarica USDT",
    "btccz":"Ricarica BTC",
    "xzbz":"Seleziona valuta",
    "sure":"Conferma",
    "ck":"Visualizza",
    "tips1":"Si prega di non ricaricare asset che non siano in questa valuta all'indirizzo sopra indicato, altrimenti gli asset non potranno essere recuperati",
    "tips2":"1. La rete di invio e la piattaforma di destinazione sono coerenti; se si sceglie come indirizzo di destinazione la rete Ethereum, è necessario selezionare la smart chain corrispondente durante l'invio. In caso di errore, non sarà possibile recuperare i propri asset digitali.",
    "tips3":"2. Assicurarsi che l'indirizzo e la rete siano coerenti prima di inviare.",
    "tips4":"Promemoria: a causa dell'anonimato e della privacy della rete blockchain, una volta inserite informazioni errate, si perderanno gli asset corrispondenti. Si prega di verificare attentamente l'indirizzo di spedizione.",
  },
  usdttb:{
    "title":"Prelievo",
    "lmc":"Tipo di catena",
    "xzl":"Seleziona catena",
    "xztbdz":"Seleziona indirizzo di prelievo",
    "qsrtbdz":"Inserisci l'indirizzo di prelievo",
    "tbdz":"Indirizzo di prelievo",
    "qsrdz":"Inserisci l'indirizzo",
    "tbsl":"Importo di prelievo",
    "tbsl2":"Importo di prelievo",
    "qsrtbsl":"Inserisci l'importo di prelievo",
    "sjtxje":"Importo di prelievo effettivo",
    "qsrsjtxje":"Inserisci l'importo di prelievo effettivo",
    "dzje":"Importo del conto",
    "jymm":"Password di transazione",
    "qsrjymm":"Inserisci la password di transazione",
    "sxf":"Commissione di gestione",
    "qsrsxf":"Inserisci la commissione di gestione",
    "dzsl":"Importo del conto",
    "dzsl2":"Importo del conto ricevuto:",
    "qsrdzsl":"Inserisci l'importo del conto",
    "wxts":"Promemoria:",
    "mrzdtxcs":"Importo minimo di prelievo ogni volta:",
    "hxxf":"Necessario per il consumo",
    "cktx":"Disponibile solo per il prelievo",
    "ci":"Orari",
    "wddtxyq":"Requisiti di prelievo non soddisfatti",
    "tjcg":"Invio riuscito, attendere la revisione",
    "tips":"È possibile prelevare monete solo se la propria potenza di calcolo è superiore a 1T (ad eccezione della potenza di calcolo della macchina per il mining dell'esperienza) o se la potenza di calcolo sotto l'ombrello è superiore a 50T.",
    "dz":"Indirizzo",
    "qd":"OK",
    "zdtb":"Prelievo minimo",
  },
  kefu: {
    "title":"Contatta il servizio clienti",
    "zxkf":"Servizio clienti",
    "fzcg":"Copia riuscita",
  },
  xgdlmm:{//Modify login password
    "title":"Modifica password di accesso",
    "t1":"Password di accesso corrente",
    "t2":"Inserisci la password di accesso corrente",
    "t3":"Nuova password",
    "t4":"Inserisci 6-16 cifre e lettere",
    "t5":"Conferma password",
    "t6":"Inserisci 6-16 cifre e lettere",
    "t7":"Conferma",
    "t8":"La password non è coerente con la password di conferma",
    "mm":"Password",
    "qsrmm":"Inserisci la tua password",
    "qqrmm":"Conferma la tua password",
    "qsrsjh":"Numero di cellulare",
    "zc":"Registrati",
    "mmts":"Lunghezza password 6-12 caratteri",
  },
  sztxmm:{//Set withdrawal password
    "title":"Modifica password transazione",
    "wjtkmm":"Password transazione dimenticata",
    "qsrjdlmm":"Inserisci la password transazione corrente",
    "zh":"Account",
    "qsryxhzsj":"Inserisci il tuo indirizzo e-mail o numero di cellulare",
    "t1":"Password transazione corrente",
    "t2":"Nuova password transazione",
    "t3":"Inserisci la password transazione a 6 cifre",
    "t4":"Conferma password",
    "t5":"Hai dimenticato la password transazione?",
    "t6":"Conferma",
    "t7":"La password non è coerente con la password di conferma",
    "t8":"Password transazione",
    "yzm":"Codice di verifica",
    "qsryzm":"Inserisci il codice di verifica",
    "hqyzm":"Ottieni codice di verifica",
  },
  record: {
    "cbjl":"Registro deposito",
    "tbjl":"Registro prelievo",
    "status":"['Non esaminato','Superato','Rifiutato']",
    "bhly":"Motivo del rifiuto",
    "ldz":"Indirizzo",
    "cjsj":"Orario di creazione",
    "zzsj":"Orario di trasferimento",
    "czl":"Catena di ricarica",
    "zrl":"Catena di trasferimento",
    "jyhx":"Hash transazione",
  },
  yqm: {
    "wdyqlj":"Il mio link di invito",
    "wdyqm":"Il mio codice di invito",
    "schbyq":"Genera invito poster",
    "bctp":"Salva immagine",
    "qx":"Annulla",
    "fx":"Condividi",
    "yqm":"Copia codice invito",
    "bcewmdxc":"Salva il codice QR nell'album",
    "bcbd":"Salva locale",
  },
  "wdtd": {
    "title":"Il mio team",
    "td":"Team",
    "yqhy":"Invita amici",
    "ren":"Persona",
    "wdtdzrs":"Il numero totale del mio team",
    "uid":"UID:",
    "zh":"Account:",
    "tdrs":"Dimensioni del team:",
    "zcsj":"Data di registrazione:",
  },
  "wdyj": {
    "title":"La mia performance",
    "wdyd":"La mia generazione",
    "dyj":"Performance",
    "tdzyj":"Prestazioni totali del team",
    "uid":"UID:",
    "tdrs":"Dimensioni del team:",
    "yj":"Performance:",
  },
  "zc": {
    "title":"Risorse",
    "zzczh":"Totale risorse equivalenti",
    "dh":"Scambio",
    "yczc":"Risorse nascoste come 0",
    "xj":"Prezzo corrente",
    "zh":"Convertito",
    "zcmx":"Dettagli risorse",
  },
  "duihuang": {
    "title":"Scambio",
    "hl":"Tasso di cambio",
    "zf":"Pagamento",
    "qbdh":"Scambio tutto",
    "ky":"Disponibile",
    "dd":"Ottieni",
    "ljdh":"Riscatta ora",
    "cont":"Variazioni del tasso di cambio, soggette all'importo effettivo ricevuto",
    "yebz":"Saldo insufficiente",
    "ksslbz":"Quantità disponibile insufficiente",
    "qtxje":"Inserisci la quantità",
    "dhcg":"Scambio riuscito",
    "mrcg":"Acquisto riuscito",
    "mccg":"Venduto riuscito",
    "wtcg":"Delegazione riuscita",
    "ts":"Prompt",
    "btcmTips":"In base alle impostazioni dello smart contract, lo scambio GDCC USDT inizierà l'8 agosto 2023.",
    "qx":"Annulla",
  },
  "sign": {
    "title":"Accedi per ricevere monete",
    "title2":"Ricompensa di accesso giornaliera",
    "title3":"Ricompensa di accesso",
    "qd":"Accedi",
    "yqd":"Accesso effettuato",
    "hdgz":"Dettagli regola",
    "qdjl":"Record di check-in",
    "qdcg":"Accedi correttamente",
  },
  "langNew": {
    "wd":"Il mio",
    "jd":"Prestito",
    "jghy":"Futures",
    "xbsg":"Acquisto valuta di Singapore",
    "sylx":"Tipo di vantaggio",
    "syts":"Giorni di guadagno",
    "rsy":"Reddito giornaliero",
    "rsy2":"Reddito giornaliero",
    "yjdts":"Numero di giorni di prestito",
    "jdsy":"Reddito da prestito",
    "jdsy2":"Reddito da prestito",
    "jdrq":"Data del prestito",
    "qdsy":"Vantaggi di accesso",
    "tgsy":"Vantaggio della promozione",
    "sybl":"Rapporto di profitto",
    "sybl2":"Rapporto di profitto",
    "ljcy":"Iscriviti ora",
    "zsy":"Reddito totale USDT",
    "jdrz":"Link node",
    "jiedian":"node",
    "qsrje":"Inserisci un nodo",
    "xyb":"Avanti",
    "zhye":"Saldo del conto",
    "dzye":"Saldo dell'indirizzo",
    "zhyezh":"Saldo del conto (equivalente)",
    "zq":"Periodo:",
    "zq2":"periodo",
    "jdsl":"Importo del prestito",
    "yxbd":"Verifica e-mail",
    "qsryxzh":"Inserisci il tuo account e-mail",
    "yxgz":"L'indirizzo e-mail inserito non è conforme alle regole",
    "jxz":"In corso",
    "ywc":"Completato",
    "day":"Giorni",
    "jg":"Prezzo",
    "zwsj":"Nessun dato~",
    "wyjb":"Prestito",
    "fxjl":"Condividi Ricompensa",
    "aqsz":"Impostazioni di sicurezza",
    "wded":"La mia seconda generazione",
    "wdsd":"Le mie tre generazioni",
    "dbxe":"Limite di transazione singola",
    "tjdd":"Invia ordine",
    "tqsh":"Prelievo Riscatto",
    "shuhui":"Riscatto",
    "ljdz":"Collega indirizzo",
    "yyqh":"Cambio lingua",
    "zxkf":"Servizio clienti",
    "syl":"Restituzione giornaliera",
    "zhuanbi":"Guadagna monete",
    "zbsy":"Guadagna reddito in valuta",
    "mc":"Nome",
    "zxj":"Ultimo prezzo",
    "zfb":"Elenco in aumento",
    "shouye":"Homepage",
    "gg":"Annuncio",
    "rzz":"Certificazione",
    "yrz":"Autenticato",
    "rzsb":"Autenticazione non riuscita, autentica nuovamente",
    "cxrz":"Riautenticazione",
    "jymmts":"Imposta una password per la transazione",
  },
  "xbsg":{
    "title":"Newcoin",
    "wdsg":"Dettagli",
    "scts":"Giorni di blocco:",
    "sy":"Rimanenti",
    "ljsg":"Iscriviti ora",
    "ysk":"Esaurito",
    "xzjdy":"Iscriviti ora",
    "dy":"Iscriviti",
    "fxjg":"Prezzo di emissione",
    "fxl":"Circolazione",
    "ssrq":"Data di quotazione",
    "yxqx":"Periodo di validità",
    "qsrsl":"Inserisci l'importo",
    "syl":"Rimanenti",
    "sgrq":"Iscriviti",
    "sgsl":"Importo",
    "bz":"Moneta",
    "yebz":"Saldo USDT insufficiente",
    "tgsl":"Pass Qty",
    "shz":"In fase di revisione",
    "wtg":"Non superato",
    "ytg":"Superato",
  },
  "wydb":{
    "title":"Prestito",
    "db":"Prestito",
    "dbz":"Prestito",
    "jl":"Record",
    "jdzq":"Periodo (giorni)",
    "qhk":"Da rimborsare",
    "ljdb":"Cumulativo (usdt)",
    "dhkbs" :"Pagamento in sospeso",
    "jkje":"Importo del prestito (usdt)",
    "qsrje":"Inserisci l'importo",
    "rll":"Tasso di interesse giornaliero",
    "hkfs":"Rimborso",
    "dqych":"Scaduto",
    "lx":"Interesse",
    "fkjg":"Prestatore",
    "tpsc":"Prestito di credito (caricamento immagine)",
    "fwxx":"Informazioni sull'alloggio",
    "srzm":"Prova di reddito (rapporto di lavoro)",
    "yhmx":"Estratto conto bancario",
    "zjz":"Foto ID",
    "yd":"Ho letto e accetto",
    "xy":"Richiedi un contratto di prestito",
    "sqdb":"Clicca per richiedere catene di prestito",
    "gb":"Chiudi",
    "qd":"OK",
    "ts":"Si prega di selezionare Richiedi un contratto di prestito",
    "dbjl":"Registra",
    "hkhth":"Codice ordine",
    "wsh":"Non esaminato",
    "yfk":"Prestito",
    "sqrq":"Tempo di richiesta",
    "zq":"Ciclo",
    "dbsl":"Numero di costole",
    "zhke":"Pagamento totale",
    "yhkxq":"Dettagli di rimborso",
    "bqyhk":"Rimborsabile nel periodo corrente (USDT)",
    "hktips":"Assicurati che il saldo sia sufficiente, se il saldo non è sufficiente, ricarica prima e poi rimborsa",
    "bj":"Capitale",
    "jie":"Prestito",
    "ljhk":"Rimborso immediato",
    "qcz":"Per depositare",
    "yebzqxcz":"Saldo insufficiente, ricaricare prima e poi rimborsare",
    "znj":"Commissione per pagamento in ritardo",
    "yqts":"Giorni di ritardo",
  },
  "hkxq":{
    "dd":"Ordine",
    "fzhkdz":"Copia l'indirizzo di rimborso",
    "hkxq":"Dettagli di rimborso",
    "zlx":"Interessi totali",
    "zhk":"Rimborsi totali",
    "hkjg":"Agenzia di rimborso",
    "qschkpz":"Carica il certificato di rimborso",
    "hkpz":"Certificato di rimborso",
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"Ordine",
    "cj":"Affare",
    "jj":"Info",
    "sj":"Tempo",
    "fx":"Direzione",
    "jg":"Prezzo",
    "sl":"Quantità",
    "mr":"Acquista",
    "mc":"Vendi",
    "mp":"Offerta",
    "sp":"Vendita",
    "slb":"Q.tà",
    "fhsj":"Data di emissione",
    "fhsl":"Numero di emissione",
    "bps":"White Paper",
    "gw":"Sito Web ufficiale",
    "fz":"min",
    "xs":"ora",
    "tian":"giorni",
    "zhou":"settimana",
    "yue":"mese",
    "gd":"Altro",
    "ft":"Sottografo",
    "zt":"Grafico principale",
    "sdt":"Immagine di profondità",
    "zx":"Preferiti",
    "djck":"Clicca per visualizzare",
  },
  "jghy":{
    "jghy":"Opzioni",
    "yxhy":"Perpetuo",
    "mz":"Acquista Long",
    "md":"Acquista Short",
    "gmj":"Prezzo di acquisto",
    "jsj":"Prezzo di liquidazione",
    "xj":"Prezzo corrente",
    "fx":"Direzione",
    "sl":"Volume",
    "jgsj":"Tempo di consegna",
    "gb":"Chiudi",
    "jxxd":"Continua a effettuare un ordine",
    "cclb":"Elenco ordini",
    "zc":"Corrente",
    "lscc":"Cronologia",
    "qblx":"Tutti",
    "yk":"Profitto",
    "ddqr":"Conferma ordine",
    "dqsj":"Tempo di scadenza",
    "jssj":"Tempo di consegna",
    "sy":"Profitto",
    "tzje":"Prezzo investimento",
    "zdje":"Prezzo più basso 0",
    "kyye":"Saldo",
    "kyye2":"Saldo",
    "sxf":"Commissione:",
    "sxfl":"Commissione",
    "jypz":"Nome",
    "jyfx":"Direzione",
    "qrxd":"Conferma",
    "fs":"Linea",
    "dqye":"Saldo corrente",
  },
  "zhjl":{
    "title":"Cronologia asset",
    "cbtb":"Deposito e prelievo",
    "jymx":"Cronologia transazioni",
    "tgyj":"Commissione promozione",
    "wwc":"Annullato",
    "ywc":"Completato",
  },
  "tipsNew":{
    "wjmmts":"Recupera password tramite codice di verifica",
    "qscpztp":"Carica l'immagine del voucher",
    "emailgsts":"Le caselle di posta di input non sono conformi alle regole",
    "telgsts":"Il numero di cellulare non è corretto",
    "lcmmbyz":"Conferma la password",
    "zdsl":"Quantità minima",
    "sldydy":"Quantità maggiore o uguale a",
    "zxtzsl":"Quantità minima",
    "ddz":"In attesa",
    "xs":"Ora",
    "min":"Importo minimo",
    "max":"Importo massimo",
    "yebz":"Saldo insufficiente",
    "qsrss":"Inserisci lotti",
    "zdss":"Lotti minimi",
    "yjj":"Rifiutato",
    "shz":"Riscatto",
    "zwkfcz":"Questa valuta non è aperta al deposito",
    "jiaoge":"Consegna",
    "zhang":"Lungo",
    "die":"Corto",
  },
  "assets": {
    "total":"Conversione asset (USD)",
    "avaiable":"Disponibile",
    "conversion":"Conversione",
    "canuse":"Disponibile",
    "yczc":"Asset nascosti come 0",
  },
  "status": {
    "statusText":"['fallimento','attesa','successo']",
  },
  "langNew2":{
    "zczgz":"Asset totali",
    "hgx":"Conformità",
    "yszc":"Informativa sulla privacy",
    "gywm":"Chi siamo",
    "zb":"Arbitraggio AI",
    "mnjy":"Trading simulato",
    "xbzq":"Zona valutaria di Singapore",
    "flzq":"Rewards Hub",
    "cjmnzhcg":"Crea un account demo con successo!",
    "wdzh":"Il mio account",
    "yymnzhts":"Hai già un account virtuale, non registrarti di nuovo",
    "tcmnzh":"Esci dall'account demo",
    "mnzhgz":"Valutazione account demo",
    "mnzh":"Account demo",
    "ljdzsb":"Impossibile connettersi all'indirizzo",
    "ysq":"Autorizzato",
  },
  "c2c":{
    "bt":"C2C",
    "bt2":"Servizio di pagamento C2C",
    "cjdd":"Crea ordine",
    "mblc":"Deposito valuta fiat",
    "cjydd":"Crea un pre-ordine",
    "xmjfk":"Paga al venditore",
    "tqhb":"Preleva la tua valuta digitale",
    "ddzt":"Stato dell'ordine",
    "wdys":"I nostri vantaggi",
    "c1":"Fai trading al tuo prezzo preferito",
    "c2":"Acquista e vendi liberamente criptovalute al tuo prezzo preferito. Acquista e vendi da offerte esistenti o crea un annuncio di trading per impostare il tuo prezzo ideale.",
    "c3":"Bassa commissione di transazione",
    "c4":"Le transazioni peer-to-peer (C2C) consentono ai venditori di definire liberamente il metodo di pagamento che desiderano in modo trasparente, acquistando e vendendo criptovalute tramite oltre 700 metodi di pagamento, tra cui bonifico bancario e contanti.",
    "c5":"Metodi di pagamento multipli",
    "c6":"Il trading peer-to-peer (C2C) consente ai venditori di definire liberamente il metodo di pagamento che desiderano. Acquista e vendi criptovalute con oltre 700 metodi di pagamento, tra cui bonifico bancario e contanti.",
    "wpp":"Non abbinato",
    "ypp":"Abbinato",
    "ysx":"Scaduto",
    "ddh":"Numero ordine",
    "mrje":"Importo acquisto",
    "mrbz":"Valuta acquisto",
    "nssdgj":"Paese",
    "qsrnssdgj":"Inserisci il paese",
    "fkrxm":"Nome pagatore",
    "qsrfkrxm":"Inserisci il nome del pagatore",
    "yx":"Email",
    "qsryx":"Inserisci il tuo indirizzo e-mail",
    "mmbz":"Tipo di acquisto",
    "qxzmmbz":"Seleziona il tipo di acquisto",
    "qxz":"Seleziona",
    "fkfs":"Metodo di pagamento",
    "qtxfkfs":"Inserisci il metodo di pagamento",
    "zh":"Account",
    "fb":"Tipo di valuta di pagamento",
    "qtxfb":"Inserisci il tipo di valuta di pagamento",
    "ngmdje":"Importo del tuo acquisto",
    "qsrje":"Inserisci l'importo",
    "wxts":"Promemoria",
    "dsh":"Da rivedere",
    "ygq":"Scaduto",
    "jcwdwt":"Introduzione a C2C",
    "tjpz":"Invia voucher",
    "ckje":"Importo corrispondente",
    "qsrckje":"Inserisci l'importo corrispondente",
    "tjzzfb":"Copia del trasferimento",
    "tjjzzm":"Carta d'identità (fronte)",
    "tjjzfm":"Carta d'identità (retro)",
    "psts1":"Presta attenzione ai seguenti punti durante lo scatto",
    "psts2":"Nota che il bordo dell'immagine è completo, il carattere è chiaro e la luminosità è uniforme",
    "psts3":"Non caricare fototessere che non corrispondono al tuo nome",
    "qsczzfb":"Carica una copia del trasferimento",
    "qscjzzm":"Carica la parte anteriore della tua patente di guida",
    "qscjzfm":"Carica il retro della tua patente di guida",
    "tj":"Invia",
    "je":"Intervallo limite",
    "ljtg":"Effettua ordine",
    "sp":"Comprendere DEFI",
    "xq":"Dettagli",
    "lxkfppdd":"Contattare il servizio clienti per abbinare l'ordine",
    "szgj":"Paese",
    "qsrszgj":"Inserisci il tuo Paese",
    "fkyhmc":"Nome della banca di pagamento",
    "qsrfkyhmc":"Inserisci il nome della banca di pagamento",
    "dianhui":"Bonifico bancario/Bonifico bancario internazionale",
    "ccsr":"Inserisci qui",
  },
  "xyf":{
    "title":"Punteggio di credito",
    "pgsj":"Tempo di valutazione",
  },
  "bbjy":{
    "mr":"Acquista",
    "mc":"Vendi",
    "mai":"Acquista",
    "sell":"Vendi",
    "xj":"Limite",
    "sj":"Mercato",
    "pk":"Posizione",
    "jg":"Prezzo",
    "sl":"Q.tà",
    "ss":"Quantità",
    "mrl":"Volume di acquisto",
    "mcl":"Volume di vendita",
    "ky":"Disponibile",
    "km":"Disponibile",
    "ksell":"Commerciabile",
    "jye":"Fatturato",
    "dqwt":"Affidamento attuale",
    "lswt":"Affidamento storico",
    "jj":"Informazioni",
    "wtzl":"Totale",
    "wtjg":"Prezzo di affidamento",
    "ycjl":"Volume di trading completato",
    "cjjj":"Prezzo medio della transazione",
    "cd":"Annulla ordine",
    "xd":"Ordine",
    "wqcj":"Un affare completo",
    "ywc":"Completato",
    "ycd":"Ordine annullato",
    "zx":"Preferiti",
    "scjg":"Prezzo di mercato",
    "fhsj":"Data di emissione",
    "fhsl":"Numero di emissione",
    "bps":"White Paper",
    "gw":"Sito Web ufficiale",
    "qx":"Annulla",
    "bbjy":"Scambio",
  },
  "hyjy":{
    "mai":"Acquisto",
    "sell":"Vendita",
    "kc":"Posizioni aperte",
    "pc":"Chiudi posizioni",
    "cc":"Posizioni",
    "kp":"Chiudi",
    "kpc":"Chiudi short",
    "kcc":"Posizioni",
    "kkd":"Apri long",
    "kpd":"Chiudi long",
    "kkk":"Apri short",
    "xj":"Limite",
    "sj":"Mercato",
    "xjwt":"Ordine limite",
    "sjwt":"Prezzo di mercato",
    "pk":"Posizione",
    "jg":"Prezzo",
    "sl":"Q.tà",
    "gg":"Leva",
    "tzgg":"Leva di controllo",
    "ggbs":"Leva finanziaria",
    "mrl":"Volume di acquisto",
    "ky":"Disponibile",
    "jye":"Fatturato",
    "dqwt":"Affidamenti correnti",
    "lswt":"Affidamenti storici",
    "ptwt":"Affidamenti ordinari",
    "dqwtmr":"Affidamenti correnti (Acquista)",
    "dqwtmc":"Affidamenti correnti (Vendi)",
    "hywt":"Affidamenti contrattuali",
    "jj":"Informazioni",
    "wtzl":"Totale",
    "wtjg":"Prezzo di affidamento",
    "ycjl":"Volume di trading completato",
    "cjjj":"Prezzo medio della transazione",
    "qbcd":"Ritira tutti gli ordini",
    "cd":"Annulla ordine",
    "xd":"Ordine",
    "wqcj":"Un affare completo",
    "ywc":"Completato",
    "ycd":"Ordine annullato",
    "zx":"Preferiti",
    "scjg":"Prezzo di mercato",
    "fhsj":"Data di emissione",
    "fhsl":"Numero di emissione",
    "bps":"White Paper",
    "gw":"Sito Web ufficiale",
    "mrzd":"Apertura lunga",
    "mrpk":"Chiusura corta",
    "mczk":"Apertura corta",
    "mcpd":"Chiusura lunga",
    "mrkdkz":"Apertura lunga (rialzista)",
    "mrpkkz":"Chiusura corta (rialzista)",
    "mckkkd":"Apertura corta (ribassista)",
    "mcpdkd":"Chiusura lunga (ribassista)",
    "yxhy":"Contratto perpetuo",
    "dc":"Posizioni lunghe",
    "kcjj":"Prezzo medio della posizione aperta (BUSDT)",
    "wsxyl":"Profitto non realizzato (BUSDT)",
    "ygqpj":"Parità forte stimata (BUSDT)",
    "syl":"Reddito giornaliero",
    "cwbzj":"Posizione margin(BUSDT)",
    "cw":"Posizioni (n.)",
    "cwjz":"Valore posizione(BUSDT)",
    "bzjl":"Tasso margine",
    "kpz":"Chiusura (n.)",
    "bdzs":"Indice sottostante",
    "tzbzj":"Regola margine",
    "zyzs":"Take profit e stop loss",
    "zjbzj":"Aumenta margine",
    "jsbzj":"Riduci margine",
    "tyhy":"Contratto esperienza",
    "ccz":"Posizione (n.)",
    "cwbzjt":"Margine posizione (TBTC)",
    "zdzjbzj":"Aumento margine massimo (TBTC)",
    "zjbzjt":"Aumento margine (TBTC)",
    "zhang":"Qtà",
    "qblx":"Tutti i tipi",
    "qb":"Tutti",
    "ccjg":"Prezzo posizioni",
    "ccsl":"Posizioni Q.tà",
    "yk":"Profitti e perdite",
    "ccsj":"Tempo posizioni",
    "zy":"Take profit",
    "zs":"Stop loss",
    "zje":"Importo totale",
    "kcs":"Posizioni aperte Q.tà",
    "kcjg":"Prezzo posizioni aperte",
    "ss":"Lotti",
    "hand":"1 lotto =",
    "qx":"Annulla",
    "qr":"OK",
  },
  "bbjyNew":{
    "jylx":"Tipi di",
    "jyze":"Importo",
  },
  "langNew3":{
    "bzxq":"Dettagli sui mattoni in movimento",
    "znbz":"AI Quantitative Intelligent Brick Moving",
    "apits":"Connettiti senza problemi alle API di oltre 200 exchange in tutto il mondo",
    "jr":"Unisciti",
    "gn":"Funzione",
    "lhjs":"Introduzione alla quantificazione dei dividendi",
    "jqrts":"Come funzionano i robot?",
    "sctj":"Statistiche di mercato",
    "scqk":"Condizioni di mercato",
    "jiaoge":"Consegna",
    "zhang":"Aumento",
    "die":"Diminuzione",
    "sz":"Impostazioni",
    "qbcp":"Tutti i prodotti",
    "jrlh":"Unisciti alla quantificazione AI",
    "sywd":"0 rischi, rendimenti stabili",
    "bzbz":"Tipo di criptovaluta",
  },
  "sztkmm":{
    "title":"Imposta password di prelievo",
    "dlmm":"Password di accesso",
    "dlmmts":"Inserisci la password di accesso",
    "xmm":"Nuova password",
    "mmts":"Lunghezza password 6 cifre",
    "qrmm":"Conferma password",
    "qr":"OK",
    "qd":"OK",
    "sztkts":"Suggerimento: vai al Security Center per impostare la password della transazione",
  },
  "bzhl":{
    "title":"Dividendo",
    "gz":"Regole",
    "tgdd":"Ordine di deposito",
    "zztgdzj":"Fondi in custodia",
    "yjjrsy":"Stima giornaliera",
    "ljsy":"Reddito totale",
    "tgzdd":"Ordine in custodia",
    "cljxcp":"Prodotti della campagna strategica",
    "dbxe":"Limite",
    "rsyl":"Tasso di rendimento giornaliero",
    "zq":"Ciclo dell'ordine",
    "qmr":"Vai e acquista",
    "bbzhzc":"Attività del conto",
    "zcc":"Attività totali (USDT)",
    "dd":"Ordini",
    "buy":"Acquista",
    "jxcp":"Prodotti in evidenza",
    "ckdd":"Controlla ordine",
    "gd":"Altro",
    "xzbzts":"Semplice e sicuro. I dividendi possono essere selezionati in più valute",
    "qtbz":"Altre monete",
    "dj":"Livello",
    "cjwt":"Problemi comuni",
    "ddsl":"Quantità ordine",
    "sl":"Importo",
  },
  "bzhlgm":{
    "title":"Profitti dalla rimozione dei mattoni",
    "bzhld":"Profitti dalla rimozione dei mattoni USDT",
    "qtzq":"Ciclo di 7 giorni USDT",
    "rsyl":"Ratio di rendimento giornaliero",
    "lczq":"Ciclo finanziario",
    "dbxe":"Limite",
    "pxsj":"Tempo di pagamento dei dividendi",
    "mr":"Giornaliero",
    "dqfh":"Restituzione alla scadenza",
    "tgzj":"Capitale di custodia",
    "tqsh":"Rimborso anticipato",
    "yjsy":"Reddito previsto (USDT)",
    "kyzc":"Attività disponibili (USDT)",
    "cpjs":"Informazioni sui nostri prodotti",
    "tgje":"Inserisci importo",
    "qsrtgje":"Inserisci l'importo di custodia",
    "qb":"Tutti",
    "rm":"Clicca qui",
    "cpzq":"Ciclo del prodotto",
    "jxr":"Data di calcolo degli interessi",
    "jiexr":"Data di regolamento degli interessi",
    "yjdzr":"Data di arrivo stimata",
    "gz":"Conosci le regole e gli interessi",
  },
  "bzhlwdtg":{
    "title":"Stato dell'ordine",
    "tgz":"In custodia",
    "ywc":"Completato",
    "ysh":"Riscattato",
    "tgje":"Importo di custodia/Tempo di custodia",
    "rsyl":"Tasso di rendimento giornaliero",
    "yhl":"Profittato",
    "xdsj":"Tempo di ordinazione",
    "sh":"Riscatto",
    "ddxq":"Dettagli dell'ordine",
    "ddh":"Numero ordine",
    "syts":"Rimanente",
    "ddztxq":"Dettagli stato ordine",
  },
  "langNew4":{
    "kp":"Apertura",
    "zuoshou":"Ricevuto ieri",
    "zg":"Più alto",
    "zd":"Più basso",
    "dqjg":"Prezzo corrente",
    "pcjg":"Prezzo di chiusura",
    "gd":"Ordine in sospeso",
    "gdj":"Prezzo ordine in sospeso",
    "gdjg":"Prezzo ordine in sospeso",
    "xfbzj":"Deposito cauzionale richiesto",
    "ksrfw":"Intervallo di input disponibile",
    "shou":"Lotti",
    "fdjyk":"Utile e perdita netti variabili",
    "pcsl":"Quantità di chiusura",
    "cx":"revoca",
    "qrpc":"Conferma per chiudere la posizione",
    "sx":"Filtro",
    "cz":"Reimposta",
    "zdl":"Sapevo",
    "kccg":"Apertura di una posizione con successo!",
    "xzfx":"Scegli direzione",
    "lx":"Tipo",
    "xgcc":"Modifica posizione",
    "szzyzs":"Imposta stop profit e stop loss",
    "szhb":"Cripto",
    "gjs":"Metallo",
    "yy":"Greggio",
    "jy":"Trade",
    "jmhb":"Cripto",
    "gdsj":"Tempo ordine in sospeso",
    "gdsl":"Quantità ordine in sospeso",
    "fs":"Tempo",
   },
   "deals": {
    "issue_time":"Tempo",
    "issue_number":"Numero",
    "white_book":"Libro",
    "weburl":"Url",
    "video_url":"Video",
    "introduction":"Info",
    "onhand":"una mano uguale",
    "position":"Posizione",
    "leverorder":"Ordini con leva",
    "leverposition":"posizione con leva",
    "inputprice":"Prezzo di input",
    "inputmul":"Multiplo di input",
    "selectmul":"Scegli multiplo",
    "onehand":"una mano uguale",
    "hand":"Numero di mani di trading",
    "marketval":"Valore di mercato",
    "bond":"Obbligazioni",
    "service":"Commissione di servizio",
    "balance":"Saldo",
    "type":"Tipo",
    "risk":"Tasso di rischio",
    "total":"profitto totale",
    "onekey":"chiudendolo",
    "makemore":"(Long)",
    "makeless":"(Short)",
    "current":"Ordini aperti",
    "all":"Tutti",
    "weing":"In commissione",
    "tding":"Trading",
    "ping":"Chiusura",
    "pied":"Chiuso",
    "ceiled":"Prelevato",
    "weprice":"Prezzo commissione",
    "oprice":"Prezzo apertura",
    "nowprice":"Prezzo corrente",
    "zyprice":"Prezzo stop guadagni",
    "zsprice":"Prezzo stop-loss",
    "canbond":"Margine disponibile",
    "optime":"Orario di apertura",
    "pgtime":"Orario di chiusura",
    "znum":"Quantità convertita",
    "gprice":"Commissioni overnight",
    "pcang":"Chiusura",
    "revoke":"Prelievo",
    "fee":"Commissione",
    "you":"Prezzo di mercato ottimale",
  },
  "zyzs":{
    "title":"Take profit e stop loss",
    "zy":"Take profit",
    "zs":"Stop loss",
    "qsrzyjg":"Inserisci un prezzo Take Profit",
    "qsrzsjg":"Inserisci un prezzo Stop loss",
    "cfjglx":"Tipo di prezzo di attivazione",
    "zsjg":"Prezzo indice",
    "scjg":"Prezzo di mercato",
    "pcfs":"Metodi per chiudere le posizioni",
    "kpcw":"Chiusura",
    "qbcw":"Tutte le posizioni",
    "wxts":"Nota bene",
    "cont":"Le posizioni di chiusura del prezzo di mercato possono creare la possibilità di non riuscire a effettuare un ordine al prezzo di mercato o di ottenere profitti/stop loss a causa di forti fluttuazioni di mercato e altri problemi.",
    "qr":"OK",
  },
  "level1": {
    "name":"Nome reale",
    "idcard":"Tipo di certificato",
    "address":"Indirizzo di residenza attuale",
    "bank_number":"Numero di banca",
    "wc":"OK",
    "name_nodata":"Il nome non può essere vuoto",
    "id_card_nodata":"Il numero di certificato non può essere vuoto",
    "address_nodata":"L'indirizzo non può essere vuoto",
    "bank_number_nodata":"Il numero della carta di credito non può essere vuoto",
    "input-username":"Inserisci il tuo vero nome",
    "zjhm":"Numero del certificato",
    "input-idcard":"Inserisci il numero del tuo certificato",
    "input-address":"Inserisci il tuo indirizzo",
    "zjlx":"Tipi di documento d'identità valido",
    "qxzzjlx":"Seleziona i tipi di documento d'identità valido",
    "sfz":"Carta d'identità",
    "hz":"Passaporto",
    "jsz":"Patente di guida",
    "lxz":"Certificato per studiare all'estero",
    "zfbzh":"Conto Alipay",
    "qsrzfbzh":"Inserisci il tuo conto Alipay",
    "khh":"Apertura conto",
    "qsrkhh":"Inserisci la banca del tuo conto",
    "yhkh":"Numero di carta di credito",
    "qsryhkh":"Inserisci il numero di carta di credito",
    "zfzh":"Conto di pagamento",
    "qxzzfzh":"Seleziona un conto di pagamento",
    "gjlb":"Elenco dei paesi",
    "qxzgjlb":"Seleziona paese/regione",
    "gjhdq":"Paese/regione",
    "qtxgj":"Inserisci il paese/regione",
  },
  "gjrz":{
    "title":"Autenticazione KYC",
    "t1":"1. Sono supportate immagini inferiori a 8 MB e nei formati JPG, JPEG o PNG.",
    "t2":"2. Le foto dei documenti di identità devono essere nitide e non devono essere modificate o bloccate. La foto personale, il numero del documento e il nome del titolare del documento devono essere chiaramente visibili.",
    "t3":"3. Le foto devono essere scattate senza alcun copricapo e si raccomanda di non includere l'uso di trucco. I lineamenti del viso del titolare del documento devono essere nitidi e riconoscibili e le sue braccia devono essere completamente esposte.",
    "t4":"OK",
    "bh":"Rifiuta",
    "shz":"In fase di revisione",
    "shtg":"Approvato",
    "nyrzcg":"Hai ottenuto la certificazione con successo",
    "sczjz":"Carica foto identificative",
    "sczjzmz":"Carica foto del fronte del documento di identità",
    "sczjbmz":"Carica foto del retro del documento di identità",
    "scgrqmz":"Carica documenti e firma personale",
    "wdtjr":"Il mio referente",
    "tjrid":"ID del referente",
    "qsrtjrid":"Inserisci l'ID del referente",
    "idbcz":"L'ID del referente non esiste",
    "tjcg":"Invio riuscito",
    "tjridts":"L'ID del referente non può essere compilato da te",
    "qsrzh":"Inserisci account",
    "dl":"Accedi",
    "jc":"Scarso",
    "yb":"Generale",
    "yx":"Eccellente",
    "ldjsqh":"LME Futures",
    "wh":"Foreign Exchange",
  },
  "newReg":{
    "sjh":"Mobile",
    "yx":"Email",
    "yqm":"Codice invito",
    "yqm2":"Codice invito (facoltativo)",
    "cjzh":"Crea account",
    "sysjhzyx":"Registrati con numero di cellulare/email",
    "sj":"Mobile",
    "yhxy":"",
    "yhxy2":"Ho letto e accetto  e  ",
    "hmyzh":"Non hai ancora un account?",
    "qzc":"Registrati",
    "qbdl":"Wallet Accedi",
    "qyqbfw":"Utilizza l'APP Wallet per accedere",
    "dc":"Esci",
    "cycs":"Numero di partecipazioni"
  },
}



// WEBPACK FOOTER //
// ./src/utils/lang/it.js